import { ILogger } from ".";
import { IConfiguration } from "../../domain/configuration";
import { DefaultConfigurationFactory } from "../../infrastructure/configuration"; // ここは特別に見る.
// log4javascriptの参照を外したい場合は、LoggerをコメントアウトしてConsoleLoggerのほうのコメントアウトを外してください
import { Logger} from "./Logger";
// import { ConsoleLogger as Logger} from "./ConsoleLogger";

export class LoggerFactory {
  static getLogger(): ILogger {
    return new Logger();
  }

  static initialize(source?: IConfiguration): void {
    const configuration = source
      ? source
      : DefaultConfigurationFactory.create();
    Logger.initialize(configuration);
  }
}
